import { useTranslation } from 'react-i18next'

import {
    downloadDbDump,
    downloadLogs,
    uploadDbDump,
    uploadLogs,
} from '../../api/dump'

import DumpSection from './DumpSection/DumpSection'

import styles from './dump.module.scss'

function Dump() {
    const { t } = useTranslation()

    return (
        <section className={styles.dump}>
            <h2 className={styles.dump__title}>{t('dump')}</h2>
            <div className={styles.dump__content}>
                <DumpSection
                    downloadRequest={downloadDbDump}
                    uploadRequest={uploadDbDump}
                    title={t('database')}
                />
                <DumpSection
                    downloadRequest={downloadLogs}
                    uploadRequest={uploadLogs}
                    title={t('logs')}
                />
            </div>
        </section>
    )
}

export default Dump
